var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-pbi',{attrs:{"report-id":"5ccc6e02-e000-45e8-ae88-b13c128d99f0","group-id":"5de7d4a7-b0d1-41a8-a978-693e831cfdcd","page-name":"81f800ed-1b96-4732-a9ed-c95ed2ed76c5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }